import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { string_type, list_type, equals, uint8_type, record_type, int32_type, option_type, class_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { UTC$reflection } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";

export class CurrentMorgageValue extends Record {
    constructor(Month, ValueNow, ValueRange, ChangedDateSwedish) {
        super();
        this.Month = Month;
        this.ValueNow = ValueNow;
        this.ValueRange = (ValueRange | 0);
        this.ChangedDateSwedish = ChangedDateSwedish;
    }
}

export function CurrentMorgageValue$reflection() {
    return record_type("Containers.MortgageValue.Api.CurrentMorgageValue", [], CurrentMorgageValue, () => [["Month", class_type("System.DateOnly")], ["ValueNow", option_type(class_type("System.Decimal"))], ["ValueRange", int32_type], ["ChangedDateSwedish", UTC$reflection()]]);
}

export class HistoricalMortgageValue extends Record {
    constructor(Month, ContractValue, ValueRange, ChangedDateSwedish) {
        super();
        this.Month = Month;
        this.ContractValue = ContractValue;
        this.ValueRange = (ValueRange | 0);
        this.ChangedDateSwedish = ChangedDateSwedish;
    }
}

export function HistoricalMortgageValue$reflection() {
    return record_type("Containers.MortgageValue.Api.HistoricalMortgageValue", [], HistoricalMortgageValue, () => [["Month", class_type("System.DateOnly")], ["ContractValue", class_type("System.Decimal")], ["ValueRange", int32_type], ["ChangedDateSwedish", UTC$reflection()]]);
}

export class MortgageInvoice extends Record {
    constructor(MortgageInvoiceId, Amount, PaidAmount, RemainingAmount, DueDate, BlockedStatus) {
        super();
        this.MortgageInvoiceId = (MortgageInvoiceId | 0);
        this.Amount = Amount;
        this.PaidAmount = PaidAmount;
        this.RemainingAmount = RemainingAmount;
        this.DueDate = DueDate;
        this.BlockedStatus = BlockedStatus;
    }
}

export function MortgageInvoice$reflection() {
    return record_type("Containers.MortgageValue.Api.MortgageInvoice", [], MortgageInvoice, () => [["MortgageInvoiceId", int32_type], ["Amount", class_type("System.Decimal")], ["PaidAmount", class_type("System.Decimal")], ["RemainingAmount", class_type("System.Decimal")], ["DueDate", class_type("System.DateTime")], ["BlockedStatus", uint8_type]]);
}

export function loadCurrentMortgageValue(clientNr, contractNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("mortgage/currentMortgageValue/%i/%i/"))(clientNr)(contractNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(CurrentMorgageValue$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(CurrentMorgageValue$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(CurrentMorgageValue$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function loadHistoricalMortgageValue(clientNr, contractNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("mortgage/historicalMortgageValue/%i/%i/"))(clientNr)(contractNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(HistoricalMortgageValue$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(HistoricalMortgageValue$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(HistoricalMortgageValue$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function loadMortgageInvoice(clientNr, contractNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("mortgage/invoice/%i/%i/"))(clientNr)(contractNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(MortgageInvoice$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(MortgageInvoice$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(MortgageInvoice$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

